import { Component, EventEmitter, OnInit, Output } from '@angular/core';
interface ToggleSidenav
{}

@Component({
  selector: 'app-inactive-header',
  templateUrl: './inactive-header.component.html',
  styleUrls: ['./inactive-header.component.css']
})
export class InactiveHeaderComponent implements OnInit {

  @Output() toggleSidebarForMe: EventEmitter<ToggleSidenav> = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }
  toggleSidebar() {
    this.toggleSidebarForMe.emit();
  }
}